import moment from 'moment';

// All displayed times are UTC — matches backend storage, ledger entries, and
// server logs so the same number you see in the UI lines up 1:1 with what you
// see when grepping logs or querying the database. Columns showing these
// timestamps should carry a "(UTC)" suffix in the header.
const FORMATS = {
  DATE: 'DD/MM/YYYY',
  DATE_WITH_TIME: 'DD/MM/YYYY HH:mm:ss',
  TIME_WITHOUT_DATE: 'HH:mm:ss',
};

export function serverDateToDateWithTime(date) {
  if (!date) {
    return null;
  }

  return moment.utc(date).format(FORMATS.DATE_WITH_TIME);
}

export function serverDateToDate(date) {
  if (!date) {
    return null;
  }

  return moment.utc(date).format(FORMATS.DATE);
}

export function serverDateToTimeWithoutDate(date) {
  if (!date) {
    return null;
  }

  return moment.utc(date).format(FORMATS.TIME_WITHOUT_DATE);
}

export function unixToMoment(unix) {
  return (+unix && moment(+unix)) || null;
}

export function momentToUnix(v) {
  return (v && v.valueOf()) || null;
}

export function unixFromNow(unix, startUnix = null) {
  if (!unix) return null;

  return timeSince(moment(startUnix && +startUnix).unix() - moment(+unix).unix());
}

function timeSince (sec) {
  const sec_num = parseInt(sec, 10);
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor(sec_num / 60) % 60;
  const seconds = sec_num % 60;
  // const arr = ['h', 'm', 's'];

  return `${hours !== 0 ? (hours < 10 ? '0' + hours + 'h ' : hours + 'h ') : ''}${minutes !== 0 ? (minutes < 10 ? '0' + minutes + 'm ' : minutes + 'm ') : ''}${seconds !== 0 ? (seconds < 10 ? '0' + seconds + 's ' : seconds + 's ') : ''}`
  // return [hours, minutes, seconds]
  //   .map(v => v < 10 ? '0' + v : v)
  //   .reduce((acc, cur, i) => `${acc} ${cur}${arr[i]} `, '');
}
